import { isUserId, isPhoneNumber, isEmail, isPw } from '@/utils/check'

export default {
  required: value => !!value || '필수 값 입니다.',
  isUserId: value => isUserId(value) || 'ID는 4-12자의 영문 대소문자 숫자 로만 입력 가능 합니다.',
  isPhoneNumber: value => isPhoneNumber(value) || '잘못된 형식의 전화번호 입니다.',
  isEmail: value => isEmail(value) || '잘못된 형식의 이메일 입니다.',
  isPw: value => isPw(value) || '10 ~ 20자 사이의 영문 대/소문자, 특수문자, 숫자만 입력 가능 합니다.',
  equals: (value, value2, msg) => value === value2 || msg,
  notEquals: (value, value2, msg) => value !== value2 || msg
}
